import { render, staticRenderFns } from "./ProductCustom.vue?vue&type=template&id=1a69cff9&scoped=true&"
import script from "./ProductCustom.vue?vue&type=script&lang=ts&"
export * from "./ProductCustom.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCustom.vue?vue&type=style&index=0&id=1a69cff9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a69cff9",
  null
  
)

export default component.exports